/* ============================================================
   蔵出し市 ／ 値引き表示
   ・時刻の判定はすべて「絶対時刻（エポック秒）」で行います。
     日付の文字列を組み立てないので、閲覧者の端末が何時間帯でも
     日本時間で切り替わります。海外からでもズレません。
   ・JSが動かない環境では、通常価格が1行だけ出ます（壊れません）。
   ============================================================ */
(function () {
  'use strict';

  /* 節（セクション）はいくつかに分かれているので、探す起点は document です。
     日程はページに1つだけ置き、ヒーローもカレンダーも同じものを読みます。 */
  var root = document;
  if (!root.querySelector('[data-kdi]')) return;

  var cfgEl = document.getElementById('kdi-schedule');
  if (!cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.days || !cfg.days.length) return;

  /* ── 金額の整形 ───────────────────────────────
     shop.money_format をそのまま使います（¥1,234 など）。 */
  var FMT = cfg.money_format || '¥{{amount_no_decimals_with_comma_separator}}';

  function comma(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function money(cents) {
    var yen = cents / 100;
    return FMT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      switch (key) {
        case 'amount':
          return comma(Math.floor(yen)) + '.' + ('0' + Math.round((yen % 1) * 100)).slice(-2);
        case 'amount_no_decimals':
          return String(Math.round(yen));
        case 'amount_with_comma_separator':
          return comma(Math.floor(yen)) + '.' + ('0' + Math.round((yen % 1) * 100)).slice(-2);
        case 'amount_no_decimals_with_comma_separator':
          return comma(Math.round(yen));
        default:
          return comma(Math.round(yen));
      }
    });
  }

  /* 割引後の価格。
     Shopifyの自動割引は四捨五入。ここは切り上げにしてあります。
     こうしておくと「カートの金額がLPより高い」ことが絶対に起きません
     （最大1円、カートのほうが安く出ます）。 */
  function discounted(cents, pct) {
    return Math.ceil(cents * (100 - pct) / 100);
  }

  /* ── いま何日目か ─────────────────────────── */
  var days = cfg.days.slice().sort(function (a, b) { return a.start - b.start; });
  var opensAt = days[0].start * 1000;
  var closesAt = days[days.length - 1].end * 1000;

  function phase(now) {
    if (now < opensAt) return { state: 'before', next: opensAt };
    if (now >= closesAt) return { state: 'after', next: null };
    for (var i = 0; i < days.length; i++) {
      var s = days[i].start * 1000, e = days[i].end * 1000;
      if (now >= s && now < e) {
        return { state: 'open', index: i, day: days[i], next: e };
      }
    }
    return { state: 'after', next: null };
  }

  /* ── 部品 ─────────────────────────────────── */
  var bar     = root.querySelector('[data-kdi-bar]');
    /* バーを body の直下へ移す（テーマの入れ物の影響を受けず、必ず画面下に固定される） */
  if (bar && bar.parentNode !== document.body) {
    bar.classList.add('kdi');          /* 色の変数を引き継ぐ */
    document.body.appendChild(bar);
  }
    /* スマホでは LINE の固定バナー（画面下いっぱい）の上にバーを積む。
     バナーが無い・右下の小箱（PC）のときは、画面の一番下のまま */
  function liftBar() {
    if (!bar) return;
    var fb = document.querySelector('.custom-floating-banner');
    var h = 0;
    if (fb) {
      var s = getComputedStyle(fb), r = fb.getBoundingClientRect();
      if (s.display !== 'none' && s.visibility !== 'hidden' && s.position === 'fixed' &&
          r.height > 0 && r.width >= window.innerWidth * 0.9 &&
          r.bottom >= window.innerHeight - 2) {
        h = Math.round(r.height);
      }
    }
    bar.style.bottom = h + 'px';
    /* ページの最後がバーとバナーに隠れないよう、余白も合わせる */
    var sp = document.querySelector('.kdi-barspacer');
    if (sp) sp.style.height = (bar.offsetHeight + h) + 'px';
  }
  liftBar();
  window.addEventListener('load', liftBar);
  window.addEventListener('resize', liftBar);
  var barDay  = root.querySelector('[data-kdi-bar-day]');
  var barPct  = root.querySelector('[data-kdi-bar-pct]');
  var barLeft = root.querySelector('[data-kdi-bar-left]');
  var cells   = root.querySelectorAll('[data-kdi-cal-day]');
  var cards   = root.querySelectorAll('[data-kdi-card]');
  var counts  = root.querySelectorAll('[data-kdi-count]');
  var lastPct = null;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function writeCountdown(ms) {
    var t = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600),
        m = Math.floor(t % 3600 / 60), s = t % 60;
    counts.forEach(function (el) {
      var k = el.getAttribute('data-kdi-count');
      el.textContent = k === 'd' ? String(d)
                     : k === 'h' ? pad(h)
                     : k === 'm' ? pad(m) : pad(s);
    });
    return { d: d, h: h, m: m, s: s };
  }

  /* 価格を書き込む（割引率が変わったときだけ走らせる） */
  function paintPrices(pct) {
    cards.forEach(function (card) {
      var cents = parseInt(card.getAttribute('data-price'), 10);
      if (isNaN(cents)) return;

      if (pct === null || card.hasAttribute('data-nosale')) {
        card.removeAttribute('data-live');
        return;
      }
      var now = discounted(cents, pct);
      var nowEl = card.querySelector('[data-kdi-now]');
      var offEl = card.querySelector('[data-kdi-off]');
      if (nowEl) nowEl.textContent = money(now);
      if (offEl) offEl.textContent = '▲' + money(cents - now) + ' 引き';
      card.setAttribute('data-live', '');
    });
  }

  /* ── 毎秒 ─────────────────────────────────── */
  function tick() {
    var now = Date.now();
    var p = phase(now);

    if (bar) bar.setAttribute('data-state', p.state);

    if (p.state === 'open') {
      var pct = p.day.pct;
      if (barDay) barDay.textContent = 'DAY ' + (p.index + 1) + ' ／ ' + p.day.label;
      if (barPct) barPct.textContent = pct + '% OFF';
      if (barLeft) {
        var t = Math.max(0, Math.floor((p.next - now) / 1000));
        barLeft.textContent = (p.index + 1 < days.length)
          ? 'この割引はあと ' + pad(Math.floor(t / 3600)) + ':' + pad(Math.floor(t % 3600 / 60)) + ':' + pad(t % 60)
          : '閉幕まで ' + pad(Math.floor(t / 3600)) + ':' + pad(Math.floor(t % 3600 / 60)) + ':' + pad(t % 60);
      }
      writeCountdown(closesAt - now);   /* ヒーローは会期の終わりまで。日ごとの残りは下の固定バーが出す */
      if (pct !== lastPct) { paintPrices(pct); lastPct = pct; }

    } else if (p.state === 'before') {
      if (barDay) barDay.textContent = '蔵出し市';
      if (barPct) barPct.textContent = days[0].pct + '% OFF から';
      if (barLeft) barLeft.textContent = '開幕まで';
      writeCountdown(opensAt - now);
      if (lastPct !== null) { paintPrices(null); lastPct = null; }

    } else {
      if (barDay) barDay.textContent = '蔵出し市';
      if (barPct) barPct.textContent = '終了';
      if (barLeft) barLeft.textContent = 'ご来場ありがとうございました';
      writeCountdown(0);
      if (lastPct !== null) { paintPrices(null); lastPct = null; }
      root.querySelectorAll('[data-kdi]').forEach(function (el) {
        el.setAttribute('data-kdi-closed', '');
      });
    }

    /* カレンダーの色分け */
    cells.forEach(function (cell, i) {
      var s = days[i] ? days[i].start * 1000 : 0;
      var e = days[i] ? days[i].end * 1000 : 0;
      cell.setAttribute('data-when', now >= e ? 'past' : (now >= s ? 'now' : 'future'));
    });
  }

  tick();
  setInterval(tick, 1000);
})();